import { useEffect, useMemo } from 'react';

type Props = {
    message?: string | null;
};

const ModelLoadingError = ({ message }: Props) => {
    const errorEl = useMemo(() => document.querySelector<HTMLElement>('.js-product-canvas-error'), []);
    const patternEl = useMemo(() => document.querySelector<HTMLElement>('.js-product-canvas-pattern-wrapper'), []);
    const patternBtnEl = useMemo(() => document.querySelector<HTMLElement>('.js-product-canvas-pattern-btn'), []);

    useEffect(() => {
        if (errorEl) {
            errorEl.textContent = message || '';
            errorEl.hidden = false;
        }

        if (patternEl) {
            patternEl.hidden = true;
        }

        if (patternBtnEl) {
            patternBtnEl.hidden = true;
        }

        document.dispatchEvent(new CustomEvent('gltf-loading-error', { detail: { message } }));
    }, []);

    return null;
};

export default ModelLoadingError;
